import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page4() {
  useEffect(() => {
    document.title = "Маяк — Страница 3"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page2" />
        <ForwardLink href="/page4" />
      </div>

      <p style={{ textAlign: "right" }}>3.</p>
      <p>
        ФОГОРН ревет громче, чем когда-либо, пронизывая до глубины<br/>
        через тела двух мужчин. ЭТО ПОТРЯСАЕТ МОЛОДОГО ЧЕЛОВЕКА –<br/>
        <i>шокирует его</i> – но не СТАРИКА. Он к этому привык.
      </p>
      <p>
        СТАРИК кладет в рот обрубок незажженной глиняной ТРУБКИ (перевернутой<br/>
        вниз). Он уходит из кадра, немного прихрамывая и довольный тем,<br/>
        что наконец оказался «снова дома».
      </p>
      <p>
        МОЛОДОЙ стоит и пялится. Его охватывает небольшой страх.<br/>
        Теперь назад пути нет.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – ВЕЧЕР</p>
      <p>МОЛОДОЙ бросает свои тяжелые припасы.</p>
      <p>Они со стуком падают на покоробленные, покрытые плесенью половицы.</p>
      <p>Он проходит через кухню и оглядывается...</p>
      <p>
        Она ветхая и пустая: угольная плита, деревенская раковина<br/>
        с водяным насосом у единственного окна, небольшой шкаф, стол<br/>
        и два стула.
      </p>
      <p>Дует ветер. Это удручает.</p>
      <p>Он продолжает осматриваться.</p>
      <p>Слышит звук капающей воды (ЗА КАДРОМ)...</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ – ПРОДОЛЖЕНИЕ</p>
      <p>
        Войдя в гостиную он видит: качалку из тростника<br/>
        со сломанным сиденьем, дребезжащую буржуйку и маленький, очень<br/>
        пыльный казенный сундук.<br/>
      </p>
      <p>ЧАСЫ монотонно тикают.</p>
      <p>
        Затем МОЛОДОЙ замечает красивый <u>СТОЛ</u> со стоящим на нем кораблем в бутылке.<br/>
        Стол заперт. Он оглядывается вокруг бегающими глазами, чтобы убедиться,<br/>
        что за ним никто не наблюдает...<br/>
      </p>
      <p>
        Инстинктивно он проводит рукой по столешнице<br/>
        к ЗАМКУ. Он трясет его. Заперто. <i>Проклятие.</i>
      </p>
      <p>
        Затем этот настойчивый звук капающей воды<br/>
        (ЗА КАДРОМ)...
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ЛЕСТНИЦА – ПРОДОЛЖЕНИЕ</p>
      <p>
        Звук становится громче по мере того, как он поднимается по узкой лестнице, каждый<br/>
        шаг сопровождается скрипом. Скрип усиливается...
      </p>
      <p style={{ textAlign: "right" }}>3.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page2" />
        <ForwardLink href="/page4" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710330835/the-lighthouse-script/amsjbjkqlzmyjyomsats.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page4;
